module.exports = __webpack_public_path__ + "static/mothersmilk-76507a983672fe03a63d33345ad6d642.jpg";